module.exports = __webpack_public_path__ + "static/media/coach-circle.459a5fbf.svg";